import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  gradient: {
    skeleton:
      "linear-gradient(120deg, #e5e5e5 30%, #f0f0f0 38%, #f0f0f0 40%, #e5e5e5 48%)",
    gradientGauge:
      "linear-gradient(90deg, #54DC9D 0%, #FFCD2E 36.98%, #FF9726 63.02%, #EE2A59 100%)",
  },
  shadow: {
    primary: "0 2px 6px -3px rgba(0,0,0,0.1)",
    box: "0 2px 10px -4px rgba(0,0,0,0.08)",
    navigation: "0px 10px 2px -2px rgba(0,0,0, 0.2)",
    btn: "0 2px 2px 1px rgba(0,0,0,0.1)",
    modal: "0 2px 6px -3px rgba(0,0,0,0.3)",
  },
  colors: {
    // PALETTE
    primary: "#1D4ED7",
    primary12: "#1D4ED71f",
    primaryActive: "#1140C3",
    secondary: "#00DEAB",
    secondaryActive: "#00BA9E",
    highlight: "#8F8DF0",
    highlightActive: "rgba(143, 141, 240, 0.2)",

    white: "#ffffff",
    whiteActive: "#F6F8FD",
    black: "#000000",
    gray: "#676767",
    lightGray: "#f0f0f0",
    camerFont: "#C6C6C6",
    checkBox: "#A8A8A8",
    disabledBtn: "#E8E8E8",
    red: "#D71D5D",
    green: "#77DA63",
    green12: "#77DA631f",

    // TEXT
    labelTxt: "#6B6B6B",
    contentLabelTxt: "#878787",
    contentTxt: "#1F1F1F",
    placeholderTxt: "#ABABAB",

    // BORDER
    linkBtnBorder: "#F2F3FC",
    divideBorder: "#EDEEF3",
    itemExpborder: "#F2F3FC",

    // BACKGROUND
    mainBg: "#FAFAFA",
    tagBg: "#3C3C3C",
    whiteBg: "#FFFFFF",
    handleBg: "#EEEEEE",
    skeleton: "#e5e5e5",
    checkBoxBg: "#165EF310",
    cameraBg: "#F0F0F0",
    homeStepBg: "#00BAAF",

    // Basic
    white100: "#ffffff",
    white80: "#ffffffcc",
    white60: "#ffffff99",
    white38: "#ffffff61",
    white12: "#ffffff1f",
    black100: "#000000",
    black90: "#000000e6",
    black80: "#000000cc",
    black70: "#000000b3",
    black60: "#00000099",
    black50: "#00000080",
    black38: "#00000061",
    black30: "#0000004C",
    black20: "#00000033",
    black12: "#0000001f",
    black10: "#00000019",
    black8: "#00000014",
    black5: "#0000000d",
    black4: "#0000000a",
    black2: "#00000005",
    gray100: "#E6E6E6",

    // LAYOUT

    // INPUT
    inputBg: "#FFFFFF",
    inputBorder: "#D9D9D9",
    inputActiveBorder: "#1D4ED7",
    inputDisabledBg: "#DFDFDF",
    checkBoxBorder: "#E0E0E0",

    // LOADING INDICATOR

    loadingIndicator1: "#4B45E70d",
    loadingIndicator2: "#4B45E719",
    loadingIndicator3: "#4B45E7",

    // TRANSPORTATION STATUS
    COMPLETED_REVIEW: "#EC9948",
    TAX_INVOICE_REQUEST_COMPLETED: "#0082CC",
    TAX_INVOICE_ERROR: "#ED220C",
    TAX_INVOICE_PUBLISHED_COMPLETED: "#4EAC2B",
    DEFAULT_STATUS: "#C2C2C2FF",
    COMPLETED: "#1D4ED7",

    //GRID
    grid: "#364964",
  },
};
